import { render, staticRenderFns } from "./offline_order_detail.vue?vue&type=template&id=d6beea06&scoped=true"
import script from "./offline_order_detail.vue?vue&type=script&lang=js"
export * from "./offline_order_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6beea06",
  null
  
)

export default component.exports